import styled from 'styled-components';

export default styled.button`
  background-color: var(--primary-color);
  border: none;
  border-radius: .25em;
  box-shadow: var(--shadow);
  color: var(--text-color-inverted);
  cursor: pointer;
  outline: none;
  padding: 1em 2em;
  text-transform: uppercase;
  transition: box-shadow 250ms;

  &:hover {
    box-shadow: var(--shadow-hover);
  }
`;
